<template>
  <div class="layout_container_sidebar">
    <div class="title flex align_center text_size_16 text_bold text_color_white padding-left-20">
      学识云•协作平台
    </div>
    <el-menu
      class="my-el-menu-no-border menu padding-top-10"
      :default-active="$route.meta.sidebar"
      :router="true"
      background-color="#335591"
      text-color="#FFFFFF"
      active-text-color="#FED44C">
      <!-- 成员是没有首页的， 成员的首页是课题组 -->
      <el-menu-item
        index="/index/home"
        class="menu_item"
        v-if="isProjectAdminToUnitContact">
        <template slot="title">
          <i class="iconfont iconzhuye"></i>
          <span>首页</span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/topic"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconketizu"></i>
          <span>项目管理</span>
        </template>
      </el-menu-item>
      <!-- 会议管理 -->
      <el-menu-item
        index="/index/meeting"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconhuiyiguanli"></i>
          <span>会议管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/issue"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconyiti"></i>
          <span>在线讨论</span>
        </template>
      </el-menu-item>
      <!-- 成员是发布了动态的 -->
      <el-menu-item
        index="/index/activities"
        class="menu_item">
        <template slot="title">
          <i class="iconfont icondongtai"></i>
          <span>项目动态</span>
        </template>
      </el-menu-item>
      <!-- 项目负责人 >= 单位联系人 的角色才有成员管理 -->
      <el-menu-item
        index="/index/member"
        class="menu_item"
        v-if="isProjectAdminToUnitContact">
        <template slot="title">
          <i class="iconfont icontuanduimingcheng"></i>
          <span>成员管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/docs"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconwendang"></i>
          <span>文档管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/resource"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconwendang"></i>
          <span>资源管理</span>
        </template>
      </el-menu-item>
      <!-- 项目负责人和联系人没有经费审核：左侧有一个模块叫经费审核；成员之前填写经费需要审核，但是现在去掉了审核的流程，所以现在 经费审核 这个模块可以隐藏掉 -->
      <!-- <el-menu-item
        v-if="!isProjectAdminOrContact"
        index="/index/message"
        class="menu_item">
        <template slot="title">
          <i class="iconfont iconshenhexiaoxi"></i>
          不能把消息通知换行下去 会出现空格的情况 导致2px 的偏差
          <span class="check text_align_left">经费审核
            <span
              v-if="(messageCount > 0) && (isTopicAdminOrContact || isUnitAdminOrContact)"
              class="dot">{{ messageCount }}
            </span>
          </span>
        </template>
      </el-menu-item> -->
      <!-- 项目负责人 >= 单位联系人 的角色才有预算管理 -->
      <el-menu-item
        index="/index/fund"
        class="menu_item"
        v-if="isProjectAdminToUnitContact"> <!-- 项目负责人 >= 单位联系人 -->
        <template slot="title">
          <i class="iconfont iconyusuan1"></i>
          <span>预算管理</span>
        </template>
      </el-menu-item>
      <!-- 通知管理 项目负责人和联系人才能进入 -->
      <el-menu-item
        index="/index/notification"
        class="menu_item"
        v-if="isProjectAdminOrContact">
        <template slot="title">
          <i class="iconfont icontongzhiguanli"></i>
          <span>通知管理</span>
        </template>
      </el-menu-item>
      <!-- 成员审批、预算修改、项目日志 只有身份是项目办的才会有 -->
      <el-menu-item
        index="/index/checkMember"
        class="menu_item"
        v-if="isProjectoOffice">
        <template slot="title">
          <i class="iconfont iconchengyuanshenpi"></i>
          <!-- <span>成员审批</span> -->
          <span class="check text_align_left">成员审批
            <span
              v-if="checkMessageCount > 0"
              class="dot">{{ checkMessageCount }}
            </span>
          </span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/updateFund"
        class="menu_item"
        v-if="isProjectoOffice">
        <template slot="title">
          <i class="iconfont iconyusuanguanli"></i>
          <span>预算修改</span>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/index/log"
        class="menu_item"
        v-if="isProjectoOffice">
        <template slot="title">
          <i class="iconfont iconrizhi"></i>
          <span>项目日志</span>
        </template>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import * as api from '~/api'
export default {
  data () {
    return {
      // 经费审核的消息数量
      messageCount: 0,
      // 成员审核的消息数量
      checkMessageCount: 0
    }
  },
  computed: {
    // 当前激活
    defaultActive () {
      return this.$route.path
    }
  },
  created () {
    // 监听事件 在审核完的时候 重新获取消息数量
    // this.$bus.on('updateMessageCount', this.getMessageCount)
    // 只有项目办才获取成员的审核消息
    if (this.isProjectoOffice) {
      // 获取待审核成员消息数量
      this.getCheckMemberCount()
    }
    // （项目负责人和联系人是没有经费审核的）课题负责人和单位负责人及其他们的联系人才有审核
    // if (this.isTopicAdminOrContact || this.isUnitAdminOrContact) {
    //   // 获取消息数量
    //   this.getMessageCount()
    // }
  },
  // 页面销毁的时候 取消监听
  /* beforeDestroy () {
    this.$bus.off('updateMessageCount')
  }, */
  methods: {
    // 获取经费消息数量
    /* getMessageCount () {
      api.getMessageCount().then(res => {
        if (res.data.code === 0) {
          console.log('获取消息数量成功', res.data.data)
          // 消息数量 [以前是成员审核的消息数量加上经费报销的消息数量] 现在只有项目办才进行人员的审核不需要此消息数量
          this.messageCount = res.data.data.expense_count
        } else {
          console.log('获取消息数量失败', res)
        }
      })
    }, */
    // 获取待审核成员消息数量
    getCheckMemberCount () {
      api.getCheckMemberMessageCount().then(res => {
        if (res.data.code === 0) {
          console.log('获取待审核成员消息数量成功', res.data.data)
          // 消息数量 [以前是成员审核的消息数量加上经费报销的消息数量] 现在只有项目办才进行人员的审核不需要此消息数量
          this.checkMessageCount = res.data.data.count
        } else {
          console.log('获取消息数量失败', res)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_container_sidebar {
    min-width: $layout-sidebar-width;
    width: $layout-sidebar-width;
    height: 100%;
    background-color: $color-primary;
    box-shadow:0px 0px 4px rgba(0,0,0,0.1);
    overflow: hidden;
    z-index: 95;
    .title {
      width: 100%;
      height: 50px;
    }
    .menu {
      .menu_item {
        i {
          margin-right: 17px;
        }
        .check {
          position: relative;
          .dot {
            position: absolute;
            top: -10px;
            right: -20px;
            background-color: #F56C6C;
            border-radius: 10px;
            color: #fff;
            display: inline-block;
            font-size: 12px;
            height: 18px;
            line-height: 18px;
            padding: 0 6px;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/index.vue